import { render, staticRenderFns } from "./TabAbout.vue?vue&type=template&id=14bdb276&scoped=true"
import script from "./TabAbout.vue?vue&type=script&lang=js"
export * from "./TabAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bdb276",
  null
  
)

export default component.exports